"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _columns = require("../../../../utils/columns");

var _SortArrow = _interopRequireDefault(require("../../../SortArrow"));

var _HelpCallout = require("../HelpCallout/HelpCallout");

var _HelpSmallIcon = require("../HelpCallout/HelpSmallIcon");

const ListHeader = props => {
  const {
    sortFilter,
    sortDirection,
    i18n,
    handleClickHeader
  } = props;
  return /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeader, {
    cursor: "pointer"
  }, /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.ID.key)
  }, _columns.actionColumns.ID.label(i18n), sortFilter === _columns.actionColumns.ID.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.DATES.key)
  }, _columns.actionColumns.DATES.label(i18n), sortFilter === _columns.actionColumns.DATES.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.STATUS.key)
  }, _columns.actionColumns.STATUS.label(i18n), sortFilter === _columns.actionColumns.STATUS.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.SITE.key)
  }, _columns.actionColumns.SITE.label(i18n), sortFilter === _columns.actionColumns.SITE.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.SUMMARY.key)
  }, _columns.actionColumns.SUMMARY.label(i18n), sortFilter === _columns.actionColumns.SUMMARY.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.SEVERITY.key)
  }, _columns.actionColumns.SEVERITY.label(i18n), sortFilter === _columns.actionColumns.SEVERITY.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.CONTEXT.key)
  }, _columns.actionColumns.CONTEXT.label(i18n), sortFilter === _columns.actionColumns.CONTEXT.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.RESPONSIBLE.key)
  }, _columns.actionColumns.RESPONSIBLE.label(i18n), sortFilter === _columns.actionColumns.RESPONSIBLE.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
    onClick: handleClickHeader(_columns.actionColumns.ESTIMATED_SAVINGS.key)
  }, _columns.actionColumns.ESTIMATED_SAVINGS.label(i18n), /*#__PURE__*/_react.default.createElement(_HelpCallout.HelpCallout, {
    id: "est-savings-help-trigger",
    renderTrigger: /*#__PURE__*/_react.default.createElement(_HelpSmallIcon.HelpSmallIcon, null)
  }, i18n._({
    id: 'columns.estimated_savings.help_text',
    message: 'Estimated, total utility + operational savings.'
  })), sortFilter === _columns.actionColumns.ESTIMATED_SAVINGS.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  })));
};

var _default = ListHeader;
exports.default = _default;
module.exports = exports.default;